import { mode } from "@chakra-ui/theme-tools";
export const buttonStyles = {
  components: {
    Button: {
      baseStyle: {
        borderRadius: "md",
        boxShadow: "none",
        transition: "background 0.15s ease, border-color 0.15s ease",
        boxSizing: "border-box",
        fontWeight: "medium",
        _focus: {
          boxShadow: "none",
        },
        _active: {
          boxShadow: "none",
        },
      },
      variants: {
        outline: () => ({
          borderRadius: "16px",
        }),
        brand: (props) => ({
          bg: mode("brand.500", "brand.400")(props),
          color: "white",
          _focus: {
            bg: mode("brand.500", "brand.400")(props),
          },
          _active: {
            bg: mode("brand.500", "brand.400")(props),
          },
          _hover: {
            bg: mode("brand.600", "brand.400")(props),
          },
        }),
        darkBrand: (props) => ({
          bg: mode("brand.900", "brand.400")(props),
          color: "white",
          _focus: {
            bg: mode("brand.900", "brand.400")(props),
          },
          _active: {
            bg: mode("brand.900", "brand.400")(props),
          },
          _hover: {
            bg: mode("brand.800", "brand.400")(props),
          },
        }),
        lightBrand: (props) => ({
          bg: mode("#F2EFFF", "whiteAlpha.100")(props),
          color: mode("brand.500", "white")(props),
          _focus: {
            bg: mode("#F2EFFF", "whiteAlpha.100")(props),
          },
          _active: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _hover: {
            bg: mode("secondaryGray.400", "whiteAlpha.200")(props),
          },
        }),
        light: (props) => ({
          bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          color: mode("secondaryGray.900", "white")(props),
          _focus: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _active: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _hover: {
            bg: mode("secondaryGray.400", "whiteAlpha.200")(props),
          },
        }),
        action: (props) => ({
          fontWeight: "500",
          borderRadius: "50px",
          bg: mode("secondaryGray.300", "brand.400")(props),
          color: mode("brand.500", "white")(props),
          _focus: {
            bg: mode("secondaryGray.300", "brand.400")(props),
          },
          _active: { bg: mode("secondaryGray.300", "brand.400")(props) },
          _hover: {
            bg: mode("secondaryGray.200", "brand.400")(props),
          },
        }),
        setup: (props) => ({
          fontWeight: "500",
          borderRadius: "50px",
          bg: mode("transparent", "brand.400")(props),
          border: mode("1px solid", "0px solid")(props),
          borderColor: mode("secondaryGray.400", "transparent")(props),
          color: mode("secondaryGray.900", "white")(props),
          _focus: {
            bg: mode("transparent", "brand.400")(props),
          },
          _active: { bg: mode("transparent", "brand.400")(props) },
          _hover: {
            bg: mode("secondaryGray.100", "brand.400")(props),
          },
        }),
        adminPrimary: () => ({
          bg: "#003064",
          color: "white",
          borderRadius: "md",
          fontWeight: "medium",
          boxShadow: "none",
          _hover: { bg: "#004080", color: "white" },
          _active: { bg: "#00264F", color: "white" },
          _focus: { boxShadow: "none" },
        }),
        adminSecondary: () => ({
          bg: "transparent",
          color: "gray.700",
          border: "1px solid",
          borderColor: "gray.300",
          borderRadius: "md",
          fontWeight: "medium",
          boxShadow: "none",
          _hover: { bg: "gray.50" },
          _focus: { boxShadow: "none" },
        }),
        adminGhost: () => ({
          bg: "transparent",
          color: "gray.600",
          borderRadius: "md",
          fontWeight: "medium",
          boxShadow: "none",
          _hover: { bg: "gray.100" },
          _focus: { boxShadow: "none" },
        }),
        adminSuccess: () => ({
          bg: "green.600",
          color: "white",
          borderRadius: "md",
          fontWeight: "medium",
          boxShadow: "none",
          _hover: { bg: "green.700" },
          _active: { bg: "green.800" },
          _focus: { boxShadow: "none" },
        }),
        adminWarning: () => ({
          bg: "yellow.400",
          color: "gray.800",
          borderRadius: "md",
          fontWeight: "medium",
          boxShadow: "none",
          _hover: { bg: "yellow.500" },
          _active: { bg: "yellow.600" },
          _focus: { boxShadow: "none" },
        }),
        adminDanger: () => ({
          bg: "red.600",
          color: "white",
          borderRadius: "md",
          fontWeight: "medium",
          boxShadow: "none",
          _hover: { bg: "red.700" },
          _active: { bg: "red.800" },
          _focus: { boxShadow: "none" },
        }),
        adminDangerOutline: () => ({
          bg: "transparent",
          color: "red.600",
          border: "1px solid",
          borderColor: "red.300",
          borderRadius: "md",
          fontWeight: "medium",
          boxShadow: "none",
          _hover: { bg: "red.50" },
          _focus: { boxShadow: "none" },
        }),
      },
    },
  },
};
